import { render, staticRenderFns } from "./customers-status.vue?vue&type=template&id=7d6c73f1&"
import script from "./customers-status.vue?vue&type=script&lang=js&"
export * from "./customers-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports